import React, { FC } from "react";
import GeneralFeedbackModal from "../../GeneralFeedbackModal";
import { useBugReportSlice } from "../../../../../../store/bugReport/useSelectors";
import {
  useChangeBugReportMessageCallback,
  useCloseBugReportModalCallback,
  useSubmitBugReport,
} from "../../../../../../store/bugReport/useActions";
import { buttonCss } from "./styles";
import { formatMsg } from "../../../../../../utils/intl/intlFormmaters";
import { PurposedButtonProps } from "../../../../../atoms/inputs/EwaButtons/types";
import { useFileStorage } from "../../../../../atoms/inputs/FlowioFileDropzone/utils";

const Container: FC = (props) => {
  const { isOpen, isSubmitting, message } = useBugReportSlice();

  const changeMessage = useChangeBugReportMessageCallback();
  const closeModal = useCloseBugReportModalCallback();

  const submitMessage = useSubmitBugReport();

  const placeholder = formatMsg("feedback.bug_report.please_describe_the_bug");
  const buttonLabel = formatMsg("common.send");
  const modalTitle = formatMsg("feedback.bug_report.report_a_bug");

  const buttonProps: PurposedButtonProps = {
    css: buttonCss,
    label: buttonLabel,
    iconName: "bug_report",
  };

  const { files, addFiles, deleteFile } = useFileStorage({ maxFiles: 5 });
  const messageInputProps = { placeholder };

  const handleSubmit = async () => {
    await submitMessage(files);
    closeModal();
  };

  return (
    <GeneralFeedbackModal
      {...props}
      files={files}
      onFileDelete={deleteFile}
      onAddFiles={addFiles}
      isOpen={isOpen}
      toggle={closeModal}
      isSubmitting={isSubmitting}
      message={message}
      changeMessage={changeMessage}
      onSubmit={handleSubmit}
      buttonProps={buttonProps}
      modalTitle={modalTitle}
      flowioInputProps={messageInputProps}
    />
  );
};

export default Container;
